import React, {Component} from 'react';
import converter from 'number-to-words';
import NumberFormat from 'react-number-format';
import $ from 'jquery';
import {Title, Noun, Pronoun, SingularPluralForm} from '../../../../model/Helper';
import PaperSignatories from '../../../../view/PaperSignatories';
import PaperSignatoriesAcknowledgement from '../../../../view/PaperSignatoriesAcknowledgement';
import PaperParty from '../../../../view/PaperParty';
import moment from 'moment';
import {blank_line} from '../../../../model/Const';

class Preview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            focus: ".paper-title"
        }
    }

    isVisible(el) {
		var elementTop = $(el).offset().top;
		var elementBottom = elementTop + $(el).outerHeight();
	
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    componentDidMount() {

		$(window).scroll(()=>{

			// This setup will be enabled only with at least md window width
			if($(window).width()>767){
				// Header setup
				// Make preview stay at the top and fixed display when header is not visible
				if(this.isVisible(".header")){
					////console.log("Visible");
					$(".right-preview .preview").css({
						"position": "relative",
						"top": "auto",
						"padding-right": "0"
					});
				} else {
					//console.log("Not visible");
					$(".right-preview .preview").css({
						"position": "fixed",
						"top": "1rem",
						"padding-right": "15px"
					});
				}

			}
        });
        
    }
    
    componentWillReceiveProps(newProps) {
		let ff = newProps.formFocus?newProps.formFocus:'paper-title';

        this.setState({
            focus: '.'+ff
        }, ()=>{
            //console.log(this.state.focus)
            let screenPos = $(window).height()/3;
            let el = $(this.state.focus).length?$(this.state.focus):$(".paper-title");
            let scrollVal = el.get(0).offsetTop-screenPos || 0;
            
            $(".paper").animate({
                scrollTop: scrollVal
            }, 100);
            
        });
    }

    render() {

        let p = this.props.details.property;
        let s = this.props.details.seller;
        let b = this.props.details.buyer;
        let pa = this.props.details.payment;

        let nounSeller = Noun(s, "seller");
        let nounBuyer = Noun(b, "buyer");

        let blankLine = blank_line;
        let blankLineLong = "_________________________________";

        let title = (Title(p)) ? Title(p) : blankLine;
        let pAddress = (p.address) ? p.address : blankLine;
        let contractDate = moment(p.contractDate).format(`LL`) || blankLine;
        let contractLocation = p.contractLocation || blankLine;

        // Natural person variables
        let sellerName = [], 
            sellerSpouseName = [],
            sellerNationality = [],
            sellerAddress = [],
            sellerRepresentativeName = [],
            sellerRepresentativeNationality = [],
            sellerRepresentativeAddress = [],
            sellerTin = [];
        // Corporation variables
        let sellerCorporationName = [],
            sellerCorporationPrincipalPlaceOfBusiness = [],
            sellerCorporationRepresentativeName = [],
            //sellerCorporationRepresentativePosition = [],
            sellerCorporationTin = [];
        this.props.details.seller.forEach((seller, i)=>{
            sellerName[i] = (seller.sellerFname || seller.sellerMname || seller.sellerLname) ? 
                                    (seller.sellerFname+(seller.sellerMname?` ${seller.sellerMname}`:"")+(seller.sellerLname?` ${seller.sellerLname}`:"")+(seller.sellerSuffix?` ${seller.sellerSuffix}`:"")): 
                                    blankLine;
            sellerSpouseName[i] = (seller.sellerSpouseFname || seller.sellerSpouseMname || seller.sellerSpouseLname) ? 
            (seller.sellerSpouseFname+(seller.sellerSpouseMname?` ${seller.sellerSpouseMname}`:"")+(seller.sellerSpouseLname?` ${seller.sellerSpouseLname}`:"")+(seller.sellerSpouseSuffix?` ${seller.sellerSpouseSuffix}`:"")): 
            blankLine;
            sellerNationality[i] = seller.sellerNationality ? seller.sellerNationality : blankLine;
            sellerAddress[i] = seller.sellerAddress ? seller.sellerAddress :  blankLine;
            
            sellerRepresentativeName[i] = (seller.sellerRepresentativeFname || seller.sellerRepresentativeMname || seller.sellerRepresentativeLname) ? 
                                    (seller.sellerRepresentativeFname+(seller.sellerRepresentativeMname?` ${seller.sellerRepresentativeMname}`:"")+(seller.sellerRepresentativeLname?` ${seller.sellerRepresentativeLname}`:"")+(seller.sellerRepresentativeSuffix?` ${seller.sellerRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerRepresentativeNationality[i] = seller.sellerRepresentativeNationality ? seller.sellerRepresentativeNationality : blankLine;
            sellerRepresentativeAddress[i] = seller.sellerRepresentativeAddress ? seller.sellerRepresentativeAddress :  blankLine;
            sellerTin[i] = seller.sellerTin ? seller.sellerTin : "";

            sellerCorporationName[i] = seller.sellerCorporationName ? seller.sellerCorporationName : blankLine;
            sellerCorporationPrincipalPlaceOfBusiness[i] = seller.sellerCorporationPrincipalPlaceOfBusiness ? seller.sellerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            sellerCorporationRepresentativeName[i] = (seller.sellerCorporationRepresentativeFname || seller.sellerCorporationRepresentativeMname || seller.sellerCorporationRepresentativeLname) ? 
                                    (seller.sellerCorporationRepresentativeFname+(seller.sellerCorporationRepresentativeMname?` ${seller.sellerCorporationRepresentativeMname}`:"")+(seller.sellerCorporationRepresentativeLname?` ${seller.sellerCorporationRepresentativeLname}`:"")+(seller.sellerCorporationRepresentativeSuffix?` ${seller.sellerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerCorporationTin[i] = seller.sellerCorporationTin ? seller.sellerCorporationTin : "";
        });

        // Natural person variables
        let buyerName = [], 
            buyerSpouseName = [],
            buyerNationality = [],
            buyerAddress = [],
            buyerRepresentativeName = [],
            buyerRepresentativeNationality = [],
            buyerRepresentativeAddress = [],
            buyerTin = [];
        // Corporation variables
        let buyerCorporationName = [],
            buyerCorporationPrincipalPlaceOfBusiness = [],
            buyerCorporationRepresentativeName = [];
        this.props.details.buyer.forEach((buyer, i)=>{
            buyerName[i] = (buyer.buyerFname || buyer.buyerMname || buyer.buyerLname) ? 
                                    (buyer.buyerFname+(buyer.buyerMname?` ${buyer.buyerMname}`:"")+(buyer.buyerLname?` ${buyer.buyerLname}`:"")+(buyer.buyerSuffix?` ${buyer.buyerSuffix}`:"")): 
                                    blankLine;
            buyerSpouseName[i] = (buyer.buyerSpouseFname || buyer.buyerSpouseMname || buyer.buyerSpouseLname) ? 
            (buyer.buyerSpouseFname+(buyer.buyerSpouseMname?` ${buyer.buyerSpouseMname}`:"")+(buyer.buyerSpouseLname?` ${buyer.buyerSpouseLname}`:"")+(buyer.buyerSpouseSuffix?` ${buyer.buyerSpouseSuffix}`:"")): 
            blankLine;
            buyerNationality[i] = buyer.buyerNationality ? buyer.buyerNationality : blankLine;
            buyerAddress[i] = buyer.buyerAddress ? buyer.buyerAddress :  blankLine;
            
            buyerRepresentativeName[i] = (buyer.buyerRepresentativeFname || buyer.buyerRepresentativeMname || buyer.buyerRepresentativeLname) ? 
                                    (buyer.buyerRepresentativeFname+(buyer.buyerRepresentativeMname?` ${buyer.buyerRepresentativeMname}`:"")+(buyer.buyerRepresentativeLname?` ${buyer.buyerRepresentativeLname}`:"")+(buyer.buyerRepresentativeSuffix?` ${buyer.buyerRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerRepresentativeNationality[i] = buyer.buyerRepresentativeNationality ? buyer.buyerRepresentativeNationality : blankLine;
            buyerRepresentativeAddress[i] = buyer.buyerRepresentativeAddress ? buyer.buyerRepresentativeAddress :  blankLine;

            buyerCorporationName[i] = buyer.buyerCorporationName ? buyer.buyerCorporationName : blankLine;
            buyerCorporationPrincipalPlaceOfBusiness[i] = buyer.buyerCorporationPrincipalPlaceOfBusiness ? buyer.buyerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            buyerCorporationRepresentativeName[i] = (buyer.buyerCorporationRepresentativeFname || buyer.buyerCorporationRepresentativeMname || buyer.buyerCorporationRepresentativeLname) ? 
                                    (buyer.buyerCorporationRepresentativeFname+(buyer.buyerCorporationRepresentativeMname?` ${buyer.buyerCorporationRepresentativeMname}`:"")+(buyer.buyerCorporationRepresentativeLname?` ${buyer.buyerCorporationRepresentativeLname}`:"")+(buyer.buyerCorporationRepresentativeSuffix?` ${buyer.buyerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerTin[i] = buyer.buyerTin ? buyer.buyerTin : "";
        });

        let priceNumber = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                                <NumberFormat value={parseFloat(p.price)} displayType="text" thousandSeparator={true} /> :
                                blankLine;		
        let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                            converter.toWords(p.price) : 
                            blankLine;
        
        let optionMoneyAmountNumber = (typeof parseFloat(p.optionMoneyAmount) === "number" && parseFloat(p.optionMoneyAmount)>0) ?
                            <NumberFormat value={parseFloat(p.optionMoneyAmount)} displayType="text" thousandSeparator={true} /> :
                            blankLine;		
        let optionMoneyAmountText = (typeof parseFloat(p.optionMoneyAmount) === "number" && parseFloat(p.optionMoneyAmount)>0) ?
                            converter.toWords(p.optionMoneyAmount) : 
                            blankLine;

        let daysReservedNumber = (typeof parseFloat(p.daysReserved) === "number" && parseFloat(p.daysReserved)>0) ?
                            <NumberFormat value={parseFloat(p.daysReserved)} displayType="text" thousandSeparator={true} /> :
                            blankLine;		
        let daysReservedText = (typeof parseFloat(p.daysReserved) === "number" && parseFloat(p.daysReserved)>0) ?
                        converter.toWords(p.daysReserved) : 
                        blankLine;

        let buyersPayArray = [];
        let sellersPayArray = [];
        pa.capitalGainTax === "seller" ?
            sellersPayArray.push("capital gains tax"):
            buyersPayArray.push("capital gains tax");
        pa.documentaryStampTax === "seller" ?
            sellersPayArray.push("documentary stamp tax"):
            buyersPayArray.push("documentary stamp tax");
        pa.transferTax === "seller" ?
            sellersPayArray.push("transfer tax"):
            buyersPayArray.push("transfer tax");
        pa.registrationFee === "seller" ?
            sellersPayArray.push("registration fee"):
            buyersPayArray.push("registration fee");
        pa.notarialFee === "seller" ?
            sellersPayArray.push("notarial fee") :
            buyersPayArray.push("notarial fee");
        if(pa.hasBroker === "Yes"){
            pa.brokerCommission === "seller" ?
                sellersPayArray.push("broker's commission") :
                buyersPayArray.push("broker's commission");
        }
        pa.creditableWithholdingTax === "seller" ?
            sellersPayArray.push("creditable withholding tax") :
            buyersPayArray.push("creditable withholding tax");
        pa.valueAddedTax === "seller" ?
            sellersPayArray.push("value added tax") :
            buyersPayArray.push("value added tax");
        let sellersPay = sellersPayArray.join(", ");
        let buyersPay = buyersPayArray.join(", ");

        return (
            <div className="preview">
                <div className="default-preview-fade top"></div>
                <div className="top-preview">
                    <div className="text-center">
                        <p>Preview</p>
                    </div>

                    <div className="paper">
                    <div className="paper-inner">
                        
                        <div className="paper-title text-center">
							{this.props.formName}
						</div>

                        <div className="text-uppercase">
                            <p className="no-indent">
                                KNOW ALL MEN BY THESE PRESENTS:
                            </p>
                        </div>

                        <div>
                            <p>
                                This {this.props.formName} (hereinafter “Contract”) made and entered into this <span className="dynamic-data text-capitalize property_contractDate">{contractDate}</span> in <span className="dynamic-data text-capitalize property_contractLocation">{contractLocation}</span>, Philippines, by and between:
                            </p>
                        </div>

                        <PaperParty party={s} type="seller" />

                        <div className="my-3 text-center">
                            <div className="my-3">- and -</div>
                        </div>

                        <PaperParty party={b} type="buyer" />

                        <div className="my-3 text-center">
                            <div className="my-3"><strong>WITNESSETH</strong>: That-</div>
                        </div>

                        <div>
                            <p>
                                1. &emsp; For and in consideration of the Option Money amounting to <span className="dynamic-data text-uppercase property_optionMoneyAmount">{optionMoneyAmountText} PESOS (P{optionMoneyAmountNumber})</span> Philippine Currency, the <span className="text-uppercase">{nounSeller}</span> hereby {SingularPluralForm(nounSeller, "grant")} the <span className="text-uppercase">{nounBuyer}</span> the exclusive right and option to purchase the real property covered by <span className="dynamic-data text-uppercase property_ctn property_tct property_oct property_type property_registrationType">{title}</span> (hereinafter "Subject Real Property"), located at <span className="dynamic-data text-capitalize property_address">{pAddress}</span>, and amounting to <span className="dynamic-data text-uppercase property_price">{priceText} PESOS (P{priceNumber})</span> Philippine Currency, <span className="font-weight-bold text-underline property_daysReserved"><u>within {daysReservedText} (<span className="dynamic-data">{daysReservedNumber}</span>) days</u></span> from the execution of this Contract. The Option Money is paid solely for this purpose and shall not form part of the purchase price.
                            </p>
                        </div>

                        <div>
                            <p>
                                2. &emsp; The <span className="text-uppercase">{nounSeller}</span> {SingularPluralForm(nounSeller, "guarantee")} that under this Contract, {Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)} will not offer the Subject Real Property for sale to any third party during the aforesaid <span className="dynamic-data">{daysReservedNumber}-day</span> period.
                            </p>
                        </div>

                        <div>
                            <p>
                                3. &emsp; During the aforesaid period, the <span className="text-uppercase">{nounBuyer}</span> may exercise {Pronoun("his", s[0].sellerGender, s[0].legalPersonality, nounBuyer)} right and option to purchase the Subject Real Property via a written notice to the <span className="text-uppercase">{nounSeller}</span>. In this regard, a Contract to Sell or Deed of Absolute Sale shall be executed within seven days from the lapse of the <span className="dynamic-data">{daysReservedNumber}-day</span> period. Should the <span className="text-uppercase">{nounBuyer}</span> fail to serve any written notice to the <span className="text-uppercase">{nounSeller}</span> within the <span className="dynamic-data">{daysReservedNumber}-day</span> period, the same shall be treated as a waiver of {Pronoun("his", s[0].sellerGender, s[0].legalPersonality, nounSeller)} right to purchase the Subject Real Property. This waiver shall likewise hold true should the <span className="text-uppercase">{nounBuyer}</span> fail to execute a Contract to Sell or Deed of Absolute Sale within the period provided, without any fault on the part of the <span className="text-uppercase">{nounSeller}</span>.
                            </p>
                        </div>

                        <div>
                            <p>
                                4. &emsp; It is likewise understood that should the <span className="text-uppercase">{nounBuyer}</span> opt to proceed with the purchase, it shall obligate {Pronoun("himself", s[0].sellerGender, s[0].legalPersonality, nounBuyer)} to pay for{buyersPayArray.length>0?<span> the <span className="payment_capitalGainTax payment_documentaryStampTax payment_transferTax payment_registrationFee payment_notarialFee payment_hasBroker payment_brokerCommission payment_creditableWithholdingTax payment_valueAddedTax">{buyersPay}</span>, and </span>:` `}other necessary expenses connected to the issuance of the corresponding title for the Subject Real Property in {Pronoun("his", s[0].sellerGender, s[0].legalPersonality, nounSeller)} name. On the other hand{sellersPayArray.length>0?`, the `:``}<span className="dynamic-data">{sellersPay}</span>, whichever is applicable, shall be for the account of the <span className="text-uppercase">{nounSeller}</span>.
                            </p>
                        </div>

                        <div>
                            <p>
                                IN WITNESS WHEREOF, the parties have executed this {this.props.formName} this _______________ in _______________.
                            </p>
                        </div>

                        <br />

                        <div>
                            <PaperSignatories party1={s} party2={b} />
                        </div>

                        <br />
                        <br />

                        <div>
                            <div>
                                <p className="no-indent">
                                    Signed in the presence of:
                                </p>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <div className="text-center">
                                        {blankLineLong}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="text-center">
                                        {blankLineLong}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <br /><br />
                        <hr />
                        <br /><br />
                        
                        {
                        /**
                         * Acknowledgement section
                         */
                        }
                        <div className="paper-top-left d-inline-block">
							<div>REPUBLIC OF THE PHILIPPINES )</div>
							<div>)S.S.</div>
						</div>

                        <div className="paper-title text-center">
							Acknowledgement
						</div>

                        <div>
                            <p>
                                BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                            </p>
                        </div>

                        <PaperSignatoriesAcknowledgement party1={s} party2={b} />

                        <div>
                            <p>
                                Known to me and to me known to be the same persons who executed the foregoing Option Contract consisting of <span className="dynamic-data"><small className="text-muted font-italic">[to be filled up by the system]</small></span> pages, including this page where the acknowledgement is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                            </p>
                            <p>
                                WITNESS MY HAND AND SEAL in the place and on the date first above written.
                            </p>
                        </div>

                        <br />
                        <br />
                        <div className="docno">
							Doc No. ________; <br />
							Page No. _______; <br />
							Book No. _______; <br />
							Series of 20 ___. <br />
						</div>	

                    </div>
                    </div> {/** End of paper */}

                </div>

                <div className="default-preview-fade"></div>
            </div>
        );
    }

}

export default Preview;



// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/option-contract/Preview.js